import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'
import { type AnchorHTMLAttributes, type ReactNode } from 'react'
const styles = stylex.create({
  link: {
    textDecoration: 'none',
    color: '#178CFA',
    cursor: 'pointer',
  },
  disabled: {
    color: colors.grey500,
    cursor: 'default',
  },
})

interface LoginLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  children: ReactNode
  onClick?: () => void
  rootStyle?: stylex.StyleXStyles
  disabled?: boolean
}

export function LoginLink(props: LoginLinkProps) {
  const { children, onClick, rootStyle, disabled, ...rest } = props
  return (
    <a onClick={disabled ? undefined : onClick} {...stylex.props(styles.link, rootStyle)} {...rest}>
      <Text variant="caption" rootStyle={[styles.link, disabled && styles.disabled]}>{children}</Text>
    </a>
  )
}
